const lazyLoadAsset = () => {
  const r = require.context('../assets/icons', false, /\.svg$/);
  return r.keys().reduce((acc, val) => ({ ...acc, [val.replace('./', '')]: r(val) }), {});
};

const regularIcons = lazyLoadAsset();

export { regularIcons };
